import { REGISTRY } from './registry.js';
import { createObserver } from './observer.js';
import { load } from './loader.js';
import { config } from './config.js';

export function init() {
  const selector = Object.keys(REGISTRY).join(', ');
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  const observer = createObserver(handleLoad);

  elements.forEach(el => {
    if (config.lazy && el.dataset.bolkLazy !== 'false') {
      observer.observe(el);
    } else {
      handleLoad(el);
    }
  });

  function handleLoad(el) {
    const sel = Object.keys(REGISTRY).find(s => el.matches(s));
    if (!sel) return;
    load(el, sel, REGISTRY[sel]);
  }
}
